// extracted by mini-css-extract-plugin
export default {"cls1":"xp46tRpc8cxtTUjDrfVq","cls2":"_tOi2inFVgHJs8aCLNwc xp46tRpc8cxtTUjDrfVq"};